import { escapeHtml } from '../inventoree/format'
import './device-links.css'

/**
 * Legaturile spre un aparat din randurile Securitee (Incidents, Detections,
 * EDR events): numele duce la pagina aparatului, "..." deschide restul.
 * Adresele sunt siruri, cu `data-spa`: `ui/spaLinks` le trece prin router, fara
 * sa reincarce aplicatia.
 */
export interface DeviceMenuItem {
  key: 'device' | 'incidents' | 'detections' | 'edr' | 'card'
  label: string
  href: string
}

/** Ziua (YYYY-MM-DD) dintr-un moment `YYYY-MM-DD HH:MM:SS`; altfel nimic. */
function dayOf(at?: string): string | undefined {
  const day = at?.slice(0, 10)
  return day && /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : undefined
}

/** Momentul `YYYY-MM-DDTHH:MM:SS` dintr-un `YYYY-MM-DD HH:MM:SS`; altfel nimic. */
function momentOf(at?: string): string | undefined {
  return at && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(at) ? at.replace(' ', 'T') : undefined
}

/** Legatura EDR events: in jurul momentului randului, sau ziua lui, sau azi. */
function edrItem(id: number, at?: string): DeviceMenuItem {
  const moment = momentOf(at)
  if (moment) return { key: 'edr', label: `EDR events around ${moment.slice(11, 16)}`, href: `/app/securitee/edr-events?device=${id}&around=${moment}` }
  const day = dayOf(at)
  return { key: 'edr', label: day ? `EDR events on ${day}` : 'EDR events today', href: `/app/securitee/edr-events?device=${id}${day ? `&day=${day}` : ''}` }
}

/** `at`: momentul detectiei / incidentului (sau numai ziua), pentru legatura EDR events. */
export function deviceMenuItems(id: number, at?: string): DeviceMenuItem[] {
  return [
    { key: 'device', label: 'Open device', href: `/app/securitee/all_devices/${id}` },
    { key: 'incidents', label: 'Incidents on this device', href: `/app/securitee/incidents?device=${id}` },
    { key: 'detections', label: 'Detections on this device', href: `/app/securitee/detections?device=${id}` },
    edrItem(id, at),
    { key: 'card', label: 'Device card', href: `/app/inventoree/device/${id}` },
  ]
}

const DASH = '<i class="fas fa-minus font-10"></i>'

/**
 * Celula "Device": numele spre pagina aparatului, apoi sertarul "..." (markupul
 * Bootstrap pe care il deschide `ui/cellDropdowns`). Fara ID sau fara nume
 * (aparat sters, alerta cu un ID strain) ramane liniuta, fara legaturi.
 */
export function deviceCellHtml(id: unknown, name: unknown, at?: string): string {
  const device = Number(id)
  const label = typeof name === 'string' ? name : ''
  if (!Number.isSafeInteger(device) || device < 1 || label === '') return label ? escapeHtml(label) : DASH

  const [open, ...rest] = deviceMenuItems(device, at)
  const items = rest
    .map((i) => (i.key === 'card' ? '<li role="separator" class="divider"></li>' : '') + `<li><a data-spa href="${escapeHtml(i.href)}">${escapeHtml(i.label)}</a></li>`)
    .join('')

  return (
    `<span class="xdr-device-cell"><a class="xdr-device-link" data-spa href="${escapeHtml(open!.href)}">${escapeHtml(label)}</a>` +
    `<span class="btn-group xdr-device-menu"><button type="button" class="btn btn-xs btn-link dropdown-toggle xdr-device-menu-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-label="More for ${escapeHtml(label)}" title="More for this device"><i class="fas fa-ellipsis-h" aria-hidden="true"></i></button>` +
    `<ul class="dropdown-menu">${items}</ul></span></span>`
  )
}
